import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../app/guards'
import { guaranteeRegisterSearchSchema } from '../../../features/projects/contracting/claims-search'
import { GuaranteesPage } from '../../../features/projects/contracting/guarantees-page'

/** The company's guarantees register and contingent liabilities (projects/04 §15.2). */
export const Route = createFileRoute('/_app/projects/guarantees')({
  staticData: { crumb: 'projectGuarantees' },
  validateSearch: guaranteeRegisterSearchSchema,
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'projects.contract', 'projects.financials'),
  component: GuaranteesPage,
})
